module.exports = __webpack_public_path__ + "img/ic-home-inactive.82d9c50c.svg";